// Shared customer-facing text for paper invoices, thermal receipts and links.
import WarrantyCoverage from "./WarrantyCoverage";

export default function WarrantyTerms({ warranty, thermal = false }) {
  if (!warranty) return null;
  return (
    <section data-testid="invoice-warranty" className={thermal ? "mt-3 border-t border-dashed border-slate-400 pt-2" : "mt-6 border-t border-slate-200 pt-3"}
      style={{ color: "#111827", fontSize: thermal ? 10 : 11, overflowWrap: "anywhere" }}>
      <h3 className="font-bold mb-2" style={{ breakAfter: "avoid" }}>Ketentuan garansi</h3>
      <WarrantyCoverage warranty={warranty} />
      {!warranty.coverage?.length && <p className="mb-2">Masa garansi belum tercatat pada invoice ini.</p>}
      {warranty.sections?.length ? warranty.sections.map(section => (
        <div key={section.key} className="mb-3 last:mb-0">
          <h4 className="font-semibold mb-1" style={{ breakAfter: "avoid" }}>{section.title}</h4>
          <p className="whitespace-pre-wrap leading-relaxed">{section.text}</p>
        </div>
      )) : <p>Ketentuan garansi belum tercatat pada invoice ini. Hubungi toko untuk informasi garansi.</p>}
    </section>
  );
}
